<template>
  <!-- Écran contextuel léger : dialogue centré, pas une deuxième feuille pleine
       hauteur. Le parent vient de répondre à une question, on lui en pose une
       dernière, courte, avec une sortie aussi visible que l'entrée. -->
  <AppSheet
    mode="centered"
    :is-open="followupOpen"
    data-testid="paywall-tech-followup"
    @update:is-open="followupOpen = $event"
    @did-dismiss="onFollowupDismissed"
  >
    <div class="px-6 pt-6 pb-5 text-center">
      <span class="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-[14px] bg-joy-soft text-brand-deep">
        <LucideIcon name="life-buoy" :size="20" />
      </span>

      <h2 class="text-[18px] font-semibold leading-snug text-ink text-balance">
        {{ t('paywall.dismiss_reason.tech_followup.title') }}
      </h2>
      <p class="mt-1.5 text-[14px] leading-relaxed text-ink-3 text-balance">
        {{ t('paywall.dismiss_reason.tech_followup.subtitle') }}
      </p>

      <div class="mt-5 flex flex-col gap-2">
        <Button
          expand="block"
          color="primary"
          data-testid="paywall-tech-followup-yes"
          @click="acceptSupport"
        >
          {{ t('paywall.dismiss_reason.tech_followup.yes') }}
        </Button>
        <Button
          expand="block"
          color="light"
          color-variant="clear"
          data-testid="paywall-tech-followup-no"
          @click="declineSupport"
        >
          {{ t('paywall.dismiss_reason.tech_followup.no') }}
        </Button>
      </div>
    </div>
  </AppSheet>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import AppSheet from '@/components/common/AppSheet.vue'
import LucideIcon from '@/components/common/LucideIcon.vue'
import { Button } from '@/components/ui/button'
import { usePaywallDismissReason } from '@/composables/usePaywallDismissReason'

const { t } = useI18n({ useScope: 'global' })
const { followupOpen, acceptSupport, declineSupport, onFollowupDismissed } = usePaywallDismissReason()
</script>
